'use strict' /* eslint-disable no-console */;

const search = (function() {
  let searchOpener;
  let searchCloser;
  let searchContainer;
  let searchInput;
  let activeClass = 'js-is-active';
  const breakpoint = window.matchMedia('(max-width: 991px)');
  let isMobileNav;

  function openSearch() {
    searchContainer.classList.add(activeClass);
    searchOpener.setAttribute('aria-expanded', 'true');
    searchContainer.setAttribute('aria-hidden', 'false');
    searchContainer.removeAttribute('tabindex');
    searchInput.focus();
  }

  function closeSearch() {
    searchContainer.classList.remove(activeClass);
    searchOpener.setAttribute('aria-expanded', 'false');
    searchContainer.setAttribute('aria-hidden', 'true');
    searchContainer.setAttribute('tabindex', '-1');
    searchOpener.focus();
  }

  // function toggleSearch() {
  // 	if( !searchContainer.classList.contains(activeClass) ){
  // 		openSearch();
  // 	}else{
  // 		closeSearch();
  // 	}
  // }

  /*
   * doAccessibility()
   *
   * attach aria attributes to the main nav and its toggle control
   */
  function doAccessibility() {
    isMobileNav = breakpoint.matches;
    if (isMobileNav) {
      // set the default attributes to closed
      searchOpener.setAttribute('aria-expanded', 'false');
      searchContainer.setAttribute('aria-hidden', 'true');
      searchContainer.setAttribute('tabindex', '-1');
    }
    searchContainer.setAttribute('aria-labelledby', searchOpener.id);
  }

  function init() {
    searchOpener = document.getElementById('js-search-open');
    searchCloser = document.getElementById('js-search-close');
    searchContainer = document.querySelector('.header-search');
    searchInput = document.getElementById('header-search');

    if (searchOpener && searchCloser) {
      searchOpener.addEventListener('click', openSearch);
      searchCloser.addEventListener('click', closeSearch);

      doAccessibility();
    }
  }

  window.addEventListener('DOMContentLoaded', init);
})();

export default search;



// WEBPACK FOOTER //
// ./resources/assets/js/search.js